import React from 'react'

import SelectorButton from './Autocomplete/SelectorButton'

const CountrySelector = React.lazy(() => import('./CountrySelector'))

export default (props: React.ComponentProps<typeof CountrySelector>) => {
  return (
    <React.Suspense fallback={<SelectorButton />}>
      <CountrySelector {...props} />
    </React.Suspense>
  )
}
